// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e61720be","128":"379d7707","153":"76329299","260":"77d8d7c3","396":"d1054e77","419":"554edd30","639":"eb4900da","689":"fa7be3df","800":"2900c964","838":"c3962260","936":"9406e88c","962":"4eabf86f"}[chunkId] + ".chunk.js";
};